// ─────────────────────────────────────────
//  UI HELPERS
//  Chat messages, typing indicators, stream bubbles, navigation
// ─────────────────────────────────────────

import { S } from './state.js';
import { esc, extractCode } from './utils.js';

// ── Chat Messages ──
export function addMsg(role, text, isMarkdown = false) {
  const msgs = document.getElementById('messages');
  if (!msgs) return;
  const div = document.createElement('div');
  div.className = 'msg ' + role;
  div.innerHTML = `
    <div class="msg-label">${role === 'user' ? 'You' : 'KasiCode AI'}</div>
    <div class="msg-bubble">${isMarkdown ? formatMarkdown(text) : esc(text)}</div>`;
  msgs.appendChild(div);
  msgs.scrollTop = msgs.scrollHeight;
}

// ── Typing indicator ──
export function showTyping() {
  const msgs = document.getElementById('messages');
  if (!msgs) return;
  let el = document.getElementById('typing-indicator');
  if (el) return;
  el = document.createElement('div');
  el.id = 'typing-indicator';
  el.className = 'msg assistant';
  el.innerHTML = `<div class="msg-label">KasiCode AI</div><div class="msg-bubble typing"><span></span><span></span><span></span></div>`;
  msgs.appendChild(el);
  msgs.scrollTop = msgs.scrollHeight;
}

export function removeTyping() {
  const el = document.getElementById('typing-indicator');
  if (el) el.remove();
}

// ── Stream bubble (for live token rendering) ──
export function createStreamBubble() {
  removeTyping();
  const msgs = document.getElementById('messages');
  if (!msgs) return { bubble: null, wrap: null };
  const wrap = document.createElement('div');
  wrap.className = 'msg assistant';
  wrap.innerHTML = `<div class="msg-label">KasiCode AI</div><div class="msg-bubble stream-bubble"></div>`;
  msgs.appendChild(wrap);
  const bubble = wrap.querySelector('.stream-bubble');
  msgs.scrollTop = msgs.scrollHeight;
  return { bubble, wrap };
}

export function renderStreamText(bubble, text) {
  if (!bubble) return;
  bubble.textContent = text + '▌';
  const msgs = document.getElementById('messages');
  if (msgs) msgs.scrollTop = msgs.scrollHeight;
}

// ── Apply buttons (shown after code is generated) ──
export function addApplyButtons(wrap, text) {
  if (!wrap) return;
  const code = extractCode(text);
  if (!code) return;

  const btns = document.createElement('div');
  btns.className = 'apply-btns';
  btns.innerHTML = `
    <button class="apply-btn primary" onclick="applyAndRun()">▶ Apply & Run</button>
    <button class="apply-btn" onclick="applyOnly()">Apply only</button>`;
  btns.dataset.code = code;
  wrap.appendChild(btns);
}

// ── Agent Steps UI ──
export function showSteps(labels) {
  const el = document.getElementById('agent-steps');
  if (!el) return;
  el.style.display = 'block';
  el.innerHTML = labels.map((l, i) => `<div class="step-item" id="step-${i}"><span class="step-dot"></span>${esc(l)}</div>`).join('');
}

export function updateStep(idx, status) {
  const el = document.getElementById('step-' + idx);
  if (!el) return;
  el.className = 'step-item ' + status;
}

export function hideSteps() {
  const el = document.getElementById('agent-steps');
  if (el) { el.style.display = 'none'; el.innerHTML = ''; }
}

export function updateStatusPill(text) {
  const el = document.getElementById('status-txt');
  if (el) el.textContent = text;
}

// ── Navigation ──
export function goView(v) {
  const prev = S.view;
  S.view = v;

  // Update nav tabs
  ['chat','code','preview'].forEach(t => {
    document.getElementById('nav-'+t)?.classList.toggle('active', t===v);
    document.getElementById('view-'+t)?.classList.remove('slide-in','slide-left');
  });

  // Slide animation
  const views = ['chat','code','preview'];
  const pi = views.indexOf(prev), ni = views.indexOf(v);

  if (ni > pi) {
    document.getElementById('view-'+prev)?.classList.add('slide-left');
    document.getElementById('view-'+v)?.classList.add('slide-in');
  } else if (ni < pi) {
    document.getElementById('view-'+v)?.classList.add('slide-in');
    document.getElementById('view-'+prev)?.classList.add('slide-left');
  } else {
    document.getElementById('view-'+v)?.classList.add('slide-in');
  }

  // Clear badges
  if (v === 'code') document.getElementById('code-badge')?.classList.remove('show');
  if (v === 'preview') document.getElementById('preview-badge')?.classList.remove('show');
}

// ── Markdown formatting (basic) ──
function formatMarkdown(text) {
  return text
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    .replace(/`(.*?)`/g, '<code>$1</code>')
    .replace(/\n/g, '<br>');
}

// ── Status helpers ──
export function setStatus(text) {
  const el = document.getElementById('status-txt');
  if (el) el.textContent = text;
}

export function showStatus(text) {
  setStatus(text);
}
